/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Build_Remove_Day_BodyInputs */

const en_us2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`The workout leaves the plan. The history of what you trained stays saved.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`The workout and its exercise leave the plan. The history of what you trained stays saved.`);
	return /** @type {LocalizedString} */ (`The workout and its ${i?.count} exercises leave the plan. The history of what you trained stays saved.`)
	
};

const pt_br2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`O treino sai do plano. O histórico do que você já treinou continua salvo.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`O treino e seu exercício saem do plano. O histórico do que você já treinou continua salvo.`);
	return /** @type {LocalizedString} */ (`O treino e seus ${i?.count} exercícios saem do plano. O histórico do que você já treinou continua salvo.`)
	
};

const es_419_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`El entrenamiento sale del plan. El historial de lo que entrenaste queda guardado.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`El entrenamiento y su ejercicio salen del plan. El historial de lo que entrenaste queda guardado.`);
	return /** @type {LocalizedString} */ (`El entrenamiento y sus ${i?.count} ejercicios salen del plan. El historial de lo que entrenaste queda guardado.`)
	
};

const pt_pt2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`O treino sai do plano. O histórico do que já treinaste continua guardado.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`O treino e o seu exercício saem do plano. O histórico do que já treinaste continua guardado.`);
	return /** @type {LocalizedString} */ (`O treino e os seus ${i?.count} exercícios saem do plano. O histórico do que já treinaste continua guardado.`)
	
};

const fr_fr2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`La séance quitte le programme. L'historique de ce que tu as fait reste enregistré.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`La séance et son exercice quittent le programme. L'historique de ce que tu as fait reste enregistré.`);
	return /** @type {LocalizedString} */ (`La séance et ses ${i?.count} exercices quittent le programme. L'historique de ce que tu as fait reste enregistré.`)
	
};

const de_de2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Das Training verschwindet aus dem Plan. Der Verlauf deiner Trainings bleibt gespeichert.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Das Training und seine Übung verschwinden aus dem Plan. Der Verlauf deiner Trainings bleibt gespeichert.`);
	return /** @type {LocalizedString} */ (`Das Training und seine ${i?.count} Übungen verschwinden aus dem Plan. Der Verlauf deiner Trainings bleibt gespeichert.`)
	
};

const it_it2_plan_build_remove_day_body = /** @type {(inputs: Plan_Build_Remove_Day_BodyInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`L'allenamento esce dalla scheda. Lo storico di quello che hai già fatto resta salvato.`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`L'allenamento e il suo esercizio escono dalla scheda. Lo storico di quello che hai già fatto resta salvato.`);
	return /** @type {LocalizedString} */ (`L'allenamento e i suoi ${i?.count} esercizi escono dalla scheda. Lo storico di quello che hai già fatto resta salvato.`)
	
};

/**
* | count | output |
* | --- | --- |
* | "0" | "The workout leaves the plan. The history of what you trained stays saved." |
* | "1" | "The workout and its exercise leave the plan. The history of what you trained stays saved." |
* | * | "The workout and its {count} exercises leave the plan. The history of what you trained stays saved." |
*
* @param {Plan_Build_Remove_Day_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_remove_day_body = /** @type {((inputs: Plan_Build_Remove_Day_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Remove_Day_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_remove_day_body(inputs)
	if (locale === "es-419") return es_419_plan_build_remove_day_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_remove_day_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_remove_day_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_remove_day_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_remove_day_body(inputs)
	return en_us2_plan_build_remove_day_body(inputs)
});
export { plan_build_remove_day_body as "plan-build.remove_day_body" }